import moment, { Moment } from 'moment';

/**
 * Документ, удостоверяющий личность
 */
export class IdentityDocument {
    /**
     * Тип документа
     * 3 - Паспорт гражданина Республики Беларусь;
     * 6 - Вид на жительство в Республике Беларусь;
     * 15 - Идентификационная карта гражданина Республики Беларусь;
     * 16 - Биометрический вид на жительство в Республике Беларусь иностранного гражданина;
     * 17 - Биометрический вид на жительство в Республике Беларусь лица без граждантсва
     */
    type: string;

    /**
     * Личный номер
     */
    personalNumber: string;

    /**
     * Серия
     */
    series: string;

    /**
     * Номер
     */
    number: string;

    /**
     * Код органа, выдавшего документ
     * Цифровой код (пример: 001 - МВД, 153 - УВД администрации Центрального района г.Минска).
     * Обязателен для типов документа: 15, 16, 17
     */
    issuerCode: string;

    /**
     * Название органа, выдавшего документ
     */
    issuerName: string;

    /**
     * Дата выдачи
     */
    issueDate: Moment;

    /**
     * Дата завершения срока действия
     */
    expirationDate: Moment;

    constructor(
        type: string,
        personalNumber: string,
        series: string,
        number: string,
        issuerCode: string,
        issuerName: string,
        issueDate: moment.Moment,
        expirationDate: moment.Moment,
    ) {
        this.type = type;
        this.personalNumber = personalNumber;
        this.series = series;
        this.number = number;
        this.issuerCode = issuerCode;
        this.issuerName = issuerName;
        this.issueDate = issueDate;
        this.expirationDate = expirationDate;
    }

    static withPersonalNumber(personalNumber: string) {
        return new IdentityDocument(
            null,
            personalNumber,
            null,
            null,
            null,
            null,
            null,
            null,
        );
    }

    static deserialize(data: any) {
        return !!data
            ? new IdentityDocument(
                  data.type,
                  data.personalNumber,
                  data.series,
                  data.number,
                  data.issuerCode,
                  data.issuerName,
                  moment(data.issueDate),
                  moment(data.expirationDate),
              )
            : null;
    }
}
